var mixins = {
    methods: {
        statusDescription(status) {
            switch (status) {
                case 1:
                    return 'Queued For Publish'
                case 2:
                    return 'Queued For Retire'
                case 3:
                    return 'Published'
                case 0:
                default:
                    return 'Out Of Date'
            }
        },
        statusToolTip(status) {
            switch (status) {
                case 1:
                    return 'Queued For Publish'
                case 2:
                    return 'Queued For Retire'
                case 3:
                    return 'Published, fully in sync with Zutak'
                case 0:
                default:
                    return 'Out Of Date'
            }
        },
        stateDescription(state) {
            switch (state) {
                case 1:
                    return 'Active'
                case 2:
                    return 'Inactive'
                case 0:
                default:
                    return 'None'
            }
        },
        stateToolTip(state) {
            switch (state) {
                case 1:
                    return 'Published to Zutak'
                case 2:
                    return 'Removed from Zutak'
                case 0:
                default:
                    return 'Never been published to Zutak'
            }
        }
    }
}

export default mixins
